import { useCallback, useEffect, useState } from 'react'
import { useAuth } from './lib/auth'
import { supabase } from './lib/supabase'
import { Connexion } from './screens/Connexion'
import { Chantiers } from './screens/Chantiers'
import { Chantier } from './screens/Chantier'
import type { Chantier as TChantier } from './lib/types'
import { useHistorique } from './lib/historique'

export function App() {
  const { session, profil, chargement } = useAuth()
  const [ouvert, setOuvert] = useState<TChantier | null>(null)
  const [cle, setCle] = useState(0)
  useHistorique(ouvert, setOuvert, (c) => c?.id ?? null)
  const [suiviCible, setSuiviCible] = useState<string | null>(null)
  const suiviCibleTraite = useCallback(() => setSuiviCible(null), [])
  const [erreurLien, setErreurLien] = useState<string | null>(null)

  /** Ouvre un chantier (et une fiche de suivi) : cloche ou lien du courriel. */
  const aller = useCallback(async (chantierId: string, suiviId: string | null) => {
    setErreurLien(null)
    const { data } = await supabase.from('chantiers').select('*').eq('id', chantierId).maybeSingle()
    if (!data) {
      setErreurLien("Ce chantier n'est pas accessible (pas de réseau, ou tu n'y es pas assigné).")
      return
    }
    setOuvert((o) => (o?.id === chantierId ? o : (data as TChantier)))
    setSuiviCible(suiviId)
  }, [])

  // Lien du courriel du matin : ?chantier=…&suivi=…
  useEffect(() => {
    if (!session || !profil) return
    const p = new URLSearchParams(window.location.search)
    const c = p.get('chantier')
    if (!c) return
    history.replaceState(history.state, '', window.location.pathname)
    void aller(c, p.get('suivi'))
  }, [session, profil, aller])

  if (chargement) {
    return (
      <div className="app">
        <p className="vide" style={{ marginTop: 80 }}>Chargement…</p>
      </div>
    )
  }

  if (!session) return <Connexion />

  if (!profil) {
    return (
      <div className="app">
        <div className="corps">
          <p className="avis" style={{ marginTop: 40 }}>
            Ton compte existe, mais son profil n'a pas encore été créé en base. Préviens un
            administrateur.
          </p>
        </div>
      </div>
    )
  }

  if (ouvert) {
    return (
      <Chantier
        key={ouvert.id}
        chantier={ouvert}
        suiviCible={suiviCible}
        suiviCibleTraite={suiviCibleTraite}
        aller={(c, s) => void aller(c, s)}
        fermer={() => {
          setOuvert(null)
          setCle((k) => k + 1) // la liste se recharge en revenant
        }}
        recharger={async () => {
          // Relit le chantier sans le fermer : on reste sur l'onglet en cours.
          const { data } = await supabase.from('chantiers').select('*').eq('id', ouvert.id).single()
          if (data) setOuvert(data as TChantier)
        }}
      />
    )
  }

  return (
    <>
      {erreurLien && (
        <p className="avis erreur" style={{ margin: 12 }} onClick={() => setErreurLien(null)}>
          {erreurLien}
        </p>
      )}
      <Chantiers key={cle} ouvrir={setOuvert} aller={(c, s) => void aller(c, s)} />
    </>
  )
}
